/* eslint-disable promise/prefer-await-to-then */
import { AppRoute, appTabs } from './AppRoute';
import { AuthCheck } from './AuthCheck';
import { Content } from './Content';
import { Edit as ContentEdit } from './Content/Edit';
import { New } from './Content/New';
import { Layout } from './Layout';
import { useLocationWithConfirmation } from './lib/useLocationWithConfirmation';
// import { Center, Loader } from '@mantine/core';
import { type FC, lazy } from 'react';
import { Redirect, Switch, Router as Wouter } from 'wouter';

const Signin = lazy(() =>
  import('./Signin').then((module) => ({ default: module.Signin })),
);

const Signup = lazy(() =>
  import('./Signup').then((module) => ({ default: module.Signup })),
);

// const Wizard = lazy(() =>
//   import('./Config/Wizard').then((module) => ({ default: module.Wizard })),
// );

const Models = lazy(() =>
  import('./Models').then((module) => ({ default: module.Models })),
);
const Model = lazy<FC>(() =>
  import('./Models/Model').then((module) => ({
    default: module.Model,
  })),
);
const Components = lazy(() =>
  import('./Components').then((module) => ({ default: module.Components })),
);
const Component = lazy<FC>(() =>
  import('./Components/Component').then((module) => ({
    default: module.Component,
  })),
);

// const MyLoader = () => (
//   <Center h="300">
//     <Loader
//       size="sm"
//       type="dots"
//     />
//   </Center>
// );

export const Router = () => {
  return (
    <Wouter hook={useLocationWithConfirmation}>
      <Switch>
        <AppRoute
          component={Signin}
          path="/signin"
        />

        <AppRoute
          component={Signup}
          path="/signup"
        />

        <AuthCheck>
          <Layout>
            <Switch>
              <AppRoute
                component={Models}
                path="/models"
                tab="models"
              />
              <AppRoute
                component={Model}
                path="/models/:id"
                tab="models"
              />
              <AppRoute
                component={Components}
                path="/components"
                tab="components"
              />
              <AppRoute
                component={Component}
                path="/components/:id"
                tab="components"
              />
              <AppRoute
                component={Content}
                path="/content/:modelId?"
                tab="content"
              />
              <AppRoute
                component={New}
                path="/content/:id/new"
                tab="content"
              />
              <AppRoute
                component={ContentEdit}
                path="/documents/:documentId"
                tab="content"
              />
              <AppRoute>
                <Redirect
                  to={
                    appTabs.get(appTabs.keys().toArray()[0])?.href || '/content'
                  }
                />
              </AppRoute>
            </Switch>
          </Layout>
        </AuthCheck>
      </Switch>
    </Wouter>
  );
};
